import React from 'react';

function FormatPercentageValue({ value }) {
  const formattedValue = value ? `${(value * 100).toFixed(2)}%` : '0%';
  return formattedValue;
}

export default React.memo(FormatPercentageValue);
